export default function RailTicketRestrictionsModalService(
    railsService
) {
    'ngInject';

    Object.assign(this, {
        getRestrictions,
        getRouteRestrictions,
    });

    function getRestrictions(code, tripId) {
        return railsService.getTicketRestrictions(code, tripId);
    }

    function getRouteRestrictions(ticketType, info) {
        return info && ticketType && ticketType.RteRestrict && findDescription() || '';

        function findDescription() {
            const item = info.find(({Code}) => ticketType.RteRestrict === Code);
            return item && item.Description;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/rail-ticket-restrictions-modal/rail-ticket-restrictions-modal-service.js